import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import QRCode from "react-qr-code";
import StudentInfo from '../FeeSystem/StudentInfo';
import moment from "moment";
import PrintHeader from '../General/PrintHeader';
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from '../General/Utility';
import RightsCheck from '../General/RightsCheck';

const PrintBiodataLists = () => {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);


    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(100000);
    const [totalRecords, setTotalRecords] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);



    const [WingName, setWingName] = useState("");
    const [ClassName, setClassName] = useState("");
    const [SessionName, setSessionName] = useState("");
    const [GroupName, setGroupName] = useState("");

    useEffect(() => {
        document.title = " Print Bio Data List"
        setLoading(true);
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const SessionId = urlParams.get('SessionId');
        const Wing_Id = urlParams.get('Wing_Id');
        const Class_Id = urlParams.get('Class_Id');
        const SectionID = urlParams.get('SectionID');
        const OrderBy = urlParams.get('OrderBy');
        const GroupId = urlParams.get('GroupId');
        const Status_Type_I = urlParams.get('Status_Type_Id');
        const GenderID = urlParams.get('Gender');
        const GroupName = urlParams.get('Gender');
        setWingName(urlParams.get('WingName'));
        setClassName(urlParams.get('ClassName'));
        setSessionName(urlParams.get('SessionName'));
        setGroupName(urlParams.get('GroupName'));


        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            SessionID: SessionId,
            Wing_Id: Wing_Id,
            Class_Id: Class_Id,
            Section_Id: SectionID,
            Registration_No: "",
            Student_ID: "",
            Keywords: "",
            Status_Type_Id: Status_Type_I,
            Group_Id: GroupId,
            OrderBy: OrderBy,
            GenderID: GenderID
        };

        //console.log(data);

        var api_config = {
            method: 'post',
            url: config.base_url + '/Student/SearchStudents',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        // console.log(data);
        axios(api_config)
            .then(function (response) {
                // console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);
                setTotalRecords(response.data.totalRecords);
                setTotalAmount(response.data.TotalAmount);

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, []);

    const renderLedger = () => {

        if (listOfLedger != null && listOfLedger.length > 0) {
            let count = 1;
            let countbreak = 1;
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}
                        //  className={countbreak++ == 35 ? 'page-break' : ''}
                        >
                            <td>{count++}</td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Student_Name}<br />{item.Bay_Form_No}</td>
                            <td>{item.Father_Name}<br />{item.Father_CNIC}</td>
                            <td>{moment(item.Date_Of_Birth).format('DD/MM/YYYY')}<br />{moment(item.Date_Of_Joining).format('DD/MM/YYYY')}</td>
                            <td style={{ width: "100px" }}>{item.Contact_Mobile}</td>
                            <td style={{ width: "100px" }}>{item.Contact_Phone}</td>
                            <td style={{ width: "200px" }}>{item.Permanent_Address}</td>
                        </tr>

                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colspan="8"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    return (
        <>
            <RightsCheck />
            <Page orientation="portrait" size="a4">
                <PrintHeader title={`Bio data list ${WingName}-${ClassName}-${SessionName} ${GroupName && (' - (' + GroupName + ' Group)')}`} />
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <th style={{ width: "10px" }}>Sr.#</th>
                            <th style={{ width: "75px" }}>Code #</th>
                            <th style={{ width: "150px" }}>Student Name<br />B-Form</th>
                            <th style={{ width: "150px" }}>Father's Name<br />Father CNIC</th>
                            <th style={{ width: "80px" }}>DOB<br />DOA</th>
                            <th style={{ width: '100px' }}>Phone</th>
                            <th style={{ width: '100px' }}>Phone</th>
                            <th>Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading ?
                                <tr>
                                    <td className="text-center" colspan="8">
                                        <Spinner animation="border" role="status"></Spinner>
                                    </td>
                                </tr>
                                :
                                <>

                                    {renderLedger()}
                                </>

                        }

                    </tbody>
                </table>
            </Page >
        </>
    );
}

export default PrintBiodataLists;
